var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ais-instant-search',{attrs:{"index-name":_vm.index,"middlewares":_vm.middlewares,"search-client":_vm.searchClient}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }